import { useState } from "react";

const deg2rad = (deg) => {
  return deg * (Math.PI / 180);
};

const calculateDistance = (lat1, lon1, lat2, lon2) => {
  const R = 6371; // شعاع زمین به کیلومتر
  const dLat = deg2rad(lat2 - lat1);
  const dLon = deg2rad(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) *
      Math.cos(deg2rad(lat2)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return parseFloat((R * c).toFixed(1)); // فاصله به کیلومتر
};

const useMapInteractions = (mapRef) => {
  const [isMapClickable, setIsMapClickable] = useState(false);
  const [isClickActive, setIsClickActive] = useState(false);
  const [points, setPoints] = useState([]);
  const [distance, setDistance] = useState(null);
  const [currentMarker, setCurrentMarker] = useState(null);
  const [isClicked, setIsClicked] = useState(false);

  const toggleMapClick = () => {
    setIsMapClickable((prev) => !prev);
  };

  const handleButtonClick = () => {
    setIsClickActive((prev) => !prev);
    setPoints([]);
    setDistance(null);
  };

  const handleAddMarker = (newMarker) => {
    setCurrentMarker(newMarker);
  };

  const handleZoomReset = () => {
    if (mapRef?.current) {
      mapRef.current.setView([32.4279, 53.688], 6);
    } else {
      console.warn("⛔ mapRef.current is undefined!");
    }
  };

  const handleClick = () => {
    if (isClicked) return;

    handleZoomReset();
    setIsClicked(true);
    setTimeout(() => setIsClicked(false), 1000);
  };

  return {
    isMapClickable,
    toggleMapClick,
    isClickActive,
    handleButtonClick,
    points,
    setPoints,
    distance,
    setDistance,
    calculateDistance,
    currentMarker,
    setCurrentMarker,
    isClicked,
    handleClick,
    handleZoomReset,
  };
};

export default useMapInteractions;
